var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSellIcon = function SvgSellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 3h1v6H2zm2 3.5h4.293L6.147 8.646l.707.707L10.207 6 6.853 2.646l-.707.707L8.294 5.5H4z"
  })));
};
export { SvgSellIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTIgMi45OTk5OEgzVjguOTk5OThIMlYyLjk5OTk4Wk00IDYuNDk5OThIOC4yOTNMNi4xNDY1IDguNjQ2NDhMNi44NTM1IDkuMzUzNDhMMTAuMjA3IDUuOTk5OThMNi44NTM1IDIuNjQ2NDhMNi4xNDY1IDMuMzUzNDhMOC4yOTMgNS40OTk5OEg0VjYuNDk5OThaIgogICAgICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIC8+Cjwvc3ZnPgo=";